<h1 mat-dialog-title>Betrieb hinzuf&uuml;gen</h1>
<div mat-dialog-content>
    <hit-anmeldung #hitAnmeldungComp [showSubmitButton]="false" (loginSuccess)="hitLoginSucceeded($event)"></hit-anmeldung>
</div>
<div mat-dialog-actions style="display: flex; width: 100%; justify-content: flex-start;">
    <button
        mat-flat-button
        color="accent"
        [disabled]="!hitAnmeldungComp?.hitFormGroup?.valid || hitAnmeldungComp?.isLoading"
        (click)="anmelden()"
    >
        Anmelden
    </button>
    <span style="flex: 1 1 auto"></span>
    <button mat-button (click)="dialogRef.close()">Abbrechen</button>
</div>
